import React from 'react';

import ConditionalComponent from '../../Shared/ConditionalComponent';

import {DefaultItem} from './DefaultItem';

export const SelectList = ({
    data,
    list,
    searchString,
    selectedOptions,
    isServerMode,
    isFetching,
    onScroll,
    onItemClick,
}) => {
    return (
        <div
            className={data.anchorEl ? 'flex-1 overflow-y-auto px-2' : 'max-h-50 overflow-y-auto'}
            style={data.anchorEl ? {} : {}}
            onScroll={isServerMode ? onScroll : undefined}
        >
            <ConditionalComponent if={!isServerMode && data.defaultValue}>
                <DefaultItem
                    item={data.defaultValue || {label: '', value: ''}}
                    index={-1}
                    isMultipleChoices={data.isMultipleChoices}
                    isChecked={selectedOptions.includes(data.defaultValue?.value)}
                    onSelect={data.handleSelect}
                    onClick={() => onItemClick(data.defaultValue, -1)}
                />
            </ConditionalComponent>

            {list.map((item, index) => {
                const isChecked = selectedOptions.includes(item.value);
                if (data.renderItem) {
                    return data.renderItem(item, isChecked, () => onItemClick(item, index));
                }
                return (
                    <DefaultItem
                        key={item.label || item.value}
                        item={item}
                        index={index}
                        isMultipleChoices={data.isMultipleChoices}
                        isChecked={isChecked}
                        onSelect={data.handleSelect}
                        onClick={() => onItemClick(item, index)}
                    />
                );
            })}

            <ConditionalComponent if={isFetching}>
                <div className="flex items-center justify-center flex-1 py-8 text-xs text-main-light">Loading...</div>
            </ConditionalComponent>

            <ConditionalComponent if={list.length === 0 && !isFetching && data.noResultText && data.handleNoResult && searchString.length > 0}>
                <button className="text-classic-button-normal" onClick={data.handleNoResult}>
                    {data.noResultText}
                </button>
            </ConditionalComponent>

            <ConditionalComponent if={list.length === 0 && !isFetching && (!data.handleNoResult || !data.noResultText)}>
                <div className="text-center py-3 text-sm text-main-disabled cursor-default">No result found</div>
            </ConditionalComponent>
        </div>
    );
};
